import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DefaultImgModule } from '../default-img/default-img.module'

import { ListItemComponent } from './list-item.component'
import { CustomMaterialModule } from '../material/custom-material.module'

@NgModule({
  imports: [
    CommonModule,
    CustomMaterialModule,
    DefaultImgModule,
  ],
  declarations: [
    ListItemComponent,
  ],
  exports: [
    ListItemComponent,
  ]
})
export class ListItemModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/list-item/list-item.module.ts